export default "__VITE_ASSET__DTbz_EfT__"